export default __webpack_public_path__ + "static/media/support-notes-logo-infobae.441f8129.svg";